export default {
  en: {
    Scenarios: 'Scenarios',
    Scenario: 'Scenario',
    Introduction: 'Introduction',
    Conditions: 'Conditions',
    Completed: 'Completed',
    Failed: 'Failed',
    Ongoing: 'Ongoing',
    scenarios: {
      welcome: 'Here are scenarios where you can practice your radio communication skills for exoctic procedures.',
      hint: 'We will add more scenarios in the future, so stay tuned! You are very welcome to suggest new scenarios.',
    }
  },
  de: {
    Scenarios: 'Szenarien',
    Scenario: 'Szenario',
    Introduction: 'Einführung',
    Conditions: 'Bedingungen',
    Completed: 'Abgeschlossen',
    Failed: 'Fehlgeschlagen',
    Ongoing: 'Laufend',
    scenarios: {
      welcome: 'Hier sind Szenarien, in denen Sie Ihre Funkkommunikationsfähigkeiten für exotische Verfahren üben können.',
      hint: 'Wir werden in Zukunft weitere Szenarien hinzufügen, also bleiben Sie dran! Sie sind herzlich eingeladen, neue Szenarien vorzuschlagen.',
    }
  },
  at: {},
  es: {
    Scenarios: 'Escenarios',
    Scenario: 'Escenario',
    Introduction: 'Introducción',
    Conditions: 'Condiciones',
    Completed: 'Completado',
    Failed: 'Fallido',
    Ongoing: 'En curso',
    scenarios: {
      welcome: 'Aquí hay escenarios donde puedes practicar tus habilidades de comunicación por radio para procedimientos exóticos.',
      hint: '¡Agregaremos más escenarios en el futuro, así que mantente atento! Eres muy bienvenido a sugerir nuevos escenarios.',
    }
  },
  uk: {
    Scenarios: 'Сценарії',
    Scenario: 'Сценарій',
    Introduction: 'Вступ',
    Conditions: 'Умови',
    Completed: 'Завершено',
    Failed: 'Не вдалося',
    Ongoing: 'Триває',
    scenarios: {
      welcome: 'Ось сценарії, в яких ви можете відпрацювати свої навички радіозв\'язку для екзотичних процедур.',
      hint: 'Ми додамо більше сценаріїв у майбутньому, тому слідкуйте за новинами! Ви дуже запрошені запропонувати нові сценарії.',
    }
  },
}
